module.exports = __webpack_public_path__ + "img/image7.8fe01259.png";